<template>
    <div class="about">
      <p v-if="!loaded">
        Загрузка
      </p>
      <div class="about-content" v-if="content(pageCode)">
        <div class="about-text" v-html="content(pageCode).DETAIL_TEXT"></div>
      </div>
    </div>
</template>
<style src="@/assets/style/company/aboutUs.scss" scoped lang="scss"></style>
<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'AboutUs',
    metaInfo() {
      return {
        title: 'О нас - EXCELSIOR',
        meta: [{
          vmid: 'description',
          name: 'description',
          content:  'О нас - интернет магазин EXCELSIOR.FASHION'
        }]
      }
    },
    data(){
      return{
        pageCode:''
      }
    },
    created() {
      this.pageCode = this.$router.currentRoute.name;
    },
    methods: {
      ...mapActions({
        loadData: 'content/getContent',
      }),
      fetchData(){
        return this.loadData(this.pageCode);
      }
    },
    computed: {
      ...mapGetters({
        content: 'content/content',
        loaded: 'content/isLoaded'
      })
    },
    mounted () {
      if(!this.content(this.pageCode)){
        this.fetchData();
      }
    },
    serverPrefetch(){
      return this.fetchData();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Company/AboutUs.vue